import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

const StatusSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setStatus = (e, { value }) => {
        dispatch(filterActionCreators.setStatus(value));
    };

    const selectedStatus = useSelector((state) => state.playersAndTeams.filter.values.status);

    const options = [
        { value: '', label: intl.formatMessage(commonMessages.playerStatusValues.allTime), key: 'all' },
        { value: 'active', label: intl.formatMessage(commonMessages.playerStatusValues.active), key: 'active' },
        { value: 'hof', label: intl.formatMessage(commonMessages.playerStatusValues.hof), key: 'hof' },
    ];
    const value = options.find((obj) => obj.value === selectedStatus);

    return (
        <Select
            onOptionChange={setStatus}
            options={options}
            selectedOption={value}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(StatusSelect);
